export interface CFSSExtracted {
  cfss_ref: string
  letter_date: string
  reply_deadline: string
  importer_name: string
  eori_number: string
  hmrc_officer: string | null
  hmrc_email: string | null
  hmrc_phone: string | null
  due_amount: number | null
  confidence: number
}

export async function parseCFSSWithClaude(pdfBase64: string): Promise<CFSSExtracted> {
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
  const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY
  if (!supabaseUrl) throw new Error('Missing VITE_SUPABASE_URL')
  if (!anonKey) throw new Error('Missing VITE_SUPABASE_ANON_KEY')

  const response = await fetch(`${supabaseUrl}/functions/v1/parse-cfss`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${anonKey}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ pdfBase64 })
  })

  if (!response.ok) {
    throw new Error('Parse error: ' + response.status + ' ' + response.statusText)
  }

  return await response.json() as CFSSExtracted
}
